// amount in ETH, from: https://etherscan.io/chart/blockreward
export const powIssuancePerDay = 13500;

export const powIssuanceYear = powIssuancePerDay * 365.25;
